import React from 'react';
import { LinearGradient } from 'expo-linear-gradient';

export const GradientWrapper = ({ colors, start, end, style, children }: any) => {
    return (
        <LinearGradient colors={colors} start={start} end={end} style={style}>
            {children}
        </LinearGradient>
    );
};

export default GradientWrapper;
